// src/langs.ts
var LANGUAGES = {
  ar: { name: "Arabic", code: "ar", direction: "rtl" },
  de: { name: "German", code: "de", direction: "ltr" },
  en: { name: "English", code: "en", direction: "ltr" },
  es: { name: "Spanish", code: "es", direction: "ltr" },
  fr: { name: "French", code: "fr", direction: "ltr" },
  ru: { name: "Russian", code: "ru", direction: "ltr" }
};

export {
  LANGUAGES
};
